import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "familiareTextBox",
  class: "AnamnesiTextBox"
}
const _hoisted_3 = { class: "AnamnesiTextBox" }
const _hoisted_4 = {
  id: "remotaTextBox",
  class: "AnamnesiTextBox"
}
const _hoisted_5 = {
  id: "prossimaTextBox",
  class: "AnamnesiTextBox"
}

import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { CollapsableModel } from '@/../../EshJSLib/models/CollapsableModel';
import { ColumnModel } from '@/../../EshJSLib/models/ColumnModel';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import AnamnesiTextBox from './AnamnesiTextBox.vue';
import AnamnesiFamiliare from './AnamnesiFamiliare.vue';
import schemaFamiliare from '@/../../EshJSLib/models/form/anamnesiFamiliare.json';
import schemaFisiologica from '@/../../EshJSLib/models/form/anamnesiFisiologica.json';
import schemaProsima from '@/../../EshJSLib/models/form/anamnesiProsima.json'
import schemaRemota from '@/../../EshJSLib/models/form/anamnesiRemota.json'
import { TblAnamnesiFamiliare } from '../../../../EshJSLib/models/patient';
import { TblAnamnesiRemota } from '../../../../EshJSLib/models/patient';
import { TblAnamnesiProssima } from '../../../../EshJSLib/models/patient';
import { saveAnamnesiFamiliare } from "../../../../EshJSLib/services/anamnesiServices";
import { saveAnamnesiRemota } from "../../../../EshJSLib/services/anamnesiServices";
import { saveAnamnesiProssima } from "../../../../EshJSLib/services/anamnesiServices";
import AnamnesiFisiologicaEdit from "./AnamnesiFisiologicaEdit.vue";
import { Modal } from 'flowbite-vue'
import { reactive,onMounted } from "vue";
import FamiliareSection from './FamiliareSection.vue';
import RemotaSection from './RemotaSection.vue';
import ProssimaSection from './ProssimaSection.vue';
import FisiologicaSection from './FisiologicaSection.vue';
interface ModalStatus {
  base: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnamnesiPage',
  setup(__props) {

const store = patientStore();

const { patient } = storeToRefs(store)
const dataModelCompletati = new CollapsableModel();
let anamnesiFamiliareNew = {} as TblAnamnesiFamiliare;
let anamnesiProssimaNew = {} as TblAnamnesiProssima;
let anamnesiRemotaNew = {} as TblAnamnesiRemota;

onMounted(async () => {
  store.fetchAnamnesiFm();
  store.fetchAnamnesiRm();
  store.fetchAnamnesiPr();
  store.fetchAnamnesiFisiologica();
  store.fetchGravidanze();

})

const isShowModal: ModalStatus = reactive({
  base: false,
});
function editFisiologica() {
  isShowModal.base = true;
}

function closeModal() {
  isShowModal.base = false;
}

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CollapsibleItem, {
          id: "familiareCollaps",
          data: _unref(schemaFamiliare)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_unref(patient).tbl_anamnesi_familiare)
                ? (_openBlock(), _createBlock(FamiliareSection, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(schemaFisiologica) }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(FisiologicaSection)
            ])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "remotaCollaps",
          data: _unref(schemaRemota)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_unref(patient).tbl_anamnesi_pt_remota)
                ? (_openBlock(), _createBlock(RemotaSection, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "prossimaCollaps",
          data: _unref(schemaProsima)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_unref(patient).tbl_anamnesi_pt_prossima)
                ? (_openBlock(), _createBlock(ProssimaSection, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}
}

})